(function () {
  'use strict';

  var modal;
  var modalImage;
  var lastTrigger;

  function isProductPage() {
    return document.body.classList.contains('template-product') ||
      document.querySelector('product-info, .sakura-jewelry-product, [data-product-id]');
  }

  function imageSource(image) {
    var srcset = image.getAttribute('srcset') || image.getAttribute('data-srcset') || '';
    var largest = srcset.split(',').map(function (candidate) {
      var parts = candidate.trim().split(/\s+/);
      return { src: parts[0], width: parseInt(parts[1], 10) || 0 };
    }).filter(function (candidate) { return candidate.src; })
      .sort(function (a, b) { return b.width - a.width; })[0];
    var src = (largest && largest.src) || image.currentSrc || image.getAttribute('src') || image.getAttribute('data-src');

    if (!src) return '';
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.delete('width');
      return url.href;
    } catch (error) {
      return src;
    }
  }

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'sakura-size-guide-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<button class="sakura-size-guide-modal__backdrop" type="button" data-size-guide-close aria-label="Close size guide"></button>' +
      '<section class="sakura-size-guide-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="SakuraSizeGuideTitle">' +
        '<header class="sakura-size-guide-modal__header">' +
          '<h2 class="sakura-size-guide-modal__title" id="SakuraSizeGuideTitle">Size Guide</h2>' +
          '<button class="sakura-size-guide-modal__close" type="button" data-size-guide-close aria-label="Close size guide"></button>' +
        '</header>' +
        '<div class="sakura-size-guide-modal__viewport">' +
          '<img class="sakura-size-guide-modal__image" alt="Size guide">' +
        '</div>' +
      '</section>';
    document.body.appendChild(modal);
    modalImage = modal.querySelector('.sakura-size-guide-modal__image');

    modal.querySelectorAll('[data-size-guide-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
    return modal;
  }

  function openModal(image, opener) {
    var src = imageSource(image);
    if (!src) return;
    ensureModal();
    lastTrigger = opener || image;
    modalImage.src = src;
    modalImage.alt = image.alt || 'Size guide';
    modal.hidden = false;
    document.documentElement.classList.add('sakura-size-guide-open');
    modal.querySelector('.sakura-size-guide-modal__close').focus();
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modalImage.removeAttribute('src');
    document.documentElement.classList.remove('sakura-size-guide-open');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }

  function activate(image) {
    if (image.dataset.sakuraSizeGuideReady === 'true') return;
    image.dataset.sakuraSizeGuideReady = 'true';
    image.classList.add('sakura-size-guide-trigger');
    image.setAttribute('role', 'button');
    image.setAttribute('tabindex', '0');
    image.setAttribute('aria-label', 'Open size guide');
    image.setAttribute('aria-haspopup', 'dialog');

    image.addEventListener('click', function (event) {
      event.preventDefault();
      openModal(image);
    });
    image.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openModal(image);
      }
    });
  }

  function preferredSizeGuideImage() {
    var images = Array.prototype.slice.call(
      document.querySelectorAll('[data-sakura-size-guide-ready="true"]')
    );
    if (!images.length) return null;

    return images.find(function (image) {
      var container = image.closest('product-info, .product, .shopify-section');
      return !container || window.getComputedStyle(container).display !== 'none';
    }) || images[0];
  }

  function activateExistingButton(button) {
    if (button.dataset.sakuraSizeGuideButtonReady === 'true') return;
    button.dataset.sakuraSizeGuideButtonReady = 'true';
    button.setAttribute('aria-haspopup', 'dialog');

    button.addEventListener('click', function (event) {
      var image = preferredSizeGuideImage();
      if (!image) return;
      event.preventDefault();
      openModal(image, button);
    });
  }

  function initialize() {
    if (!isProductPage()) return;
    var selectors = [
      '[data-sakura-product-description-content]',
      '.product__description.rte',
      '.sakura-product-left-details-outer.rte',
      '.sakura-jewelry-product__accordion-content .rte'
    ];
    var roots = [];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (root) {
        if (!roots.some(function (existing) { return existing === root || existing.contains(root); })) {
          roots.push(root);
        }
      });
    });

    roots.forEach(function (root) {
      var images = Array.prototype.filter.call(root.querySelectorAll('img'), function (image) {
        return !image.closest('.jdgm-widget, script, template');
      });
      if (images.length) activate(images[images.length - 1]);
    });

    document.querySelectorAll('a[href*="/pages/size-guide"], button[data-size-guide]').forEach(function (button) {
      activateExistingButton(button);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);

  var timer;
  new MutationObserver(function () {
    window.clearTimeout(timer);
    timer = window.setTimeout(initialize, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
